// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_form__TZmx5 {
  display: flex;
  gap: 24px;
  flex-direction: column;
  position: relative;
}
.styles_form__TZmx5 .styles_button__Hbwh6 {
  width: 100%;
  padding: 14px 0;
  font-family: "Open Sans Semi Bold";
  font-style: normal;
  font-size: 14px;
  line-height: 116%;
  outline: none;
  border: none;
  background: #49a3a6;
  border-radius: 40px;
  color: #ffffff;
  text-transform: none;
}
.styles_form__TZmx5 .styles_button__Hbwh6:hover {
  background: #49a3a6;
}
.styles_form__TZmx5 .styles_disabled__tOHer.styles_button__Hbwh6 {
  background: #b2b8bf;
  pointer-events: none;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_input__Jy7zQ {
  color: #333333;
  border: 1px solid rgb(178, 184, 191);
  border-radius: 10px;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_input__Jy7zQ input {
  height: 50px;
  color: #333333;
  box-sizing: border-box;
  outline: none;
  padding: 12px 13px;
  width: 100%;
  border-radius: 10px;
  background-color: transparent !important;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_input__Jy7zQ input::placeholder {
  color: #919ca7;
  opacity: 1;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_input__Jy7zQ input:-internal-autofill-selected {
  background-color: transparent !important;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_input__Jy7zQ input:-webkit-autofill, .styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_input__Jy7zQ input:-webkit-autofill:hover, .styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_input__Jy7zQ input:-webkit-autofill:focus {
  background-color: #ffffff !important;
  border: 1px solid #ffffff;
  -webkit-text-fill-color: #333333;
  -webkit-box-shadow: 0 0 0px 1000px #ffffff inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq fieldset {
  border: none;
  outline: none;
}
.styles_form__TZmx5 .styles_inputWrapper__iHzrq .styles_helper__zy-R9 {
  position: absolute;
  bottom: -20px;
  margin-top: 0;
  opacity: 0;
  pointer-events: none;
  margin: 0 14px;
  width: calc(100% - 28px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.styles_form__TZmx5 .styles_invalid__XJBQ8 .styles_input__Jy7zQ {
  border: 1px solid rgb(223, 89, 89);
}
.styles_form__TZmx5 .styles_invalid__XJBQ8 .styles_input__Jy7zQ input {
  color: rgb(223, 89, 89);
}
.styles_form__TZmx5 .styles_invalid__XJBQ8 .styles_input__Jy7zQ input:-webkit-autofill, .styles_form__TZmx5 .styles_invalid__XJBQ8 .styles_input__Jy7zQ input:-webkit-autofill:hover, .styles_form__TZmx5 .styles_invalid__XJBQ8 .styles_input__Jy7zQ input:-webkit-autofill:focus {
  -webkit-text-fill-color: rgb(223, 89, 89);
}
.styles_form__TZmx5 .styles_invalid__XJBQ8 .styles_helper__zy-R9 {
  opacity: 1;
  pointer-events: initial;
  color: rgb(223, 89, 89);
}

.styles_imageWrapper__Fq1-e {
  width: 100%;
  height: 100%;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AACJ;AACI;EACE,mBAAA;AACN;AAGE;EACE,mBAAA;EACA,oBAAA;AADJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFJ;AAII;EACE,cAAA;EACA,oCAAA;EACA,mBAAA;AAFN;AAIM;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,wCAAA;AAFR;AAIQ;EACE,cAAA;EACA,UAAA;AAFV;AAKQ;EACE,wCAAA;AAHV;AAKQ;EAGE,oCAAA;EACA,yBAAA;EACA,gCAAA;EACA,gDAAA;EACA,yDAAA;EAAA,iDAAA;AALV;AAUI;EACE,YAAA;EACA,aAAA;AARN;AAWI;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AATN;AAcI;EACE,kCAAA;AAZN;AAcM;EACE,uBAAA;AAZR;AAaQ;EAGE,yCAAA;AAbV;AAkBI;EACE,UAAA;EACA,uBAAA;EACA,uBAAA;AAhBN;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAlBF","sourcesContent":[".form {\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n  position: relative;\n\n  .button {\n    width: 100%;\n    padding: 14px 0;\n    font-family: 'Open Sans Semi Bold';\n    font-style: normal;\n    font-size: 14px;\n    line-height: 116%;\n    outline: none;\n    border: none;\n    background: #49a3a6;\n    border-radius: 40px;\n    color: #ffffff;\n    text-transform: none;\n\n    &:hover {\n      background: #49a3a6;\n    }\n  }\n\n  .disabled.button {\n    background: #b2b8bf;\n    pointer-events: none;\n  }\n\n  .inputWrapper {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .input {\n      color: #333333;\n      border: 1px solid rgba(178, 184, 191, 1);\n      border-radius: 10px;\n\n      input {\n        height: 50px;\n        color: #333333;\n        box-sizing: border-box;\n        outline: none;\n        padding: 12px 13px;\n        width: 100%;\n        border-radius: 10px;\n        background-color: transparent !important;\n\n        &::placeholder {\n          color: #919ca7;\n          opacity: 1;\n        }\n\n        &:-internal-autofill-selected {\n          background-color: transparent !important;\n        }\n        &:-webkit-autofill,\n        &:-webkit-autofill:hover,\n        &:-webkit-autofill:focus {\n          background-color: #ffffff !important;\n          border: 1px solid #ffffff;\n          -webkit-text-fill-color: #333333;\n          -webkit-box-shadow: 0 0 0px 1000px #ffffff inset;\n          transition: background-color 5000s ease-in-out 0s;\n        }\n      }\n    }\n\n    fieldset {\n      border: none;\n      outline: none;\n    }\n\n    .helper {\n      position: absolute;\n      bottom: -20px;\n      margin-top: 0;\n      opacity: 0;\n      pointer-events: none;\n      margin: 0 14px;\n      width: calc(100% - 14px * 2);\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .invalid {\n    .input {\n      border: 1px solid rgba(223, 89, 89, 1);\n\n      input {\n        color: rgba(223, 89, 89, 1);\n        &:-webkit-autofill,\n        &:-webkit-autofill:hover,\n        &:-webkit-autofill:focus {\n          -webkit-text-fill-color: rgba(223, 89, 89, 1);\n        }\n      }\n    }\n\n    .helper {\n      opacity: 1;\n      pointer-events: initial;\n      color: rgba(223, 89, 89, 1);\n    }\n  }\n}\n\n.imageWrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `styles_form__TZmx5`,
	"button": `styles_button__Hbwh6`,
	"disabled": `styles_disabled__tOHer`,
	"inputWrapper": `styles_inputWrapper__iHzrq`,
	"input": `styles_input__Jy7zQ`,
	"helper": `styles_helper__zy-R9`,
	"invalid": `styles_invalid__XJBQ8`,
	"imageWrapper": `styles_imageWrapper__Fq1-e`
};
export default ___CSS_LOADER_EXPORT___;
